import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageLayout } from "@/components/PageLayout";
import { Reveal } from "@/components/Reveal";
import { usePageMeta } from "@/hooks/usePageMeta";
import { ARTICLES } from "@/lib/articles";

export default function EducationPage() {
  usePageMeta(
    "Education Center | J11 Consulting",
    "Educational resources from J11 Consulting on credit education, financial literacy, business credit and funding readiness."
  );

  return (
    <PageLayout
      eyebrow="Education Center"
      title="Learn Before You Apply."
      subtitle="Plain-language educational resources on credit, financial habits and funding readiness — built to help you understand the system before making financial decisions."
      testId="education-page"
    >
      <section className="bg-[#0E0E12] py-14 lg:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {ARTICLES.map((article, i) => (
              <Reveal key={article.slug} delay={(i % 3) * 0.06}>
                <Link
                  to={`/education/${article.slug}`}
                  data-testid={`education-page-card-${article.slug}`}
                  className="group flex h-full flex-col rounded-2xl border border-white/10 bg-[#17171C] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#C9A227]/30 hover:shadow-xl hover:shadow-black/40"
                >
                  <div className="flex items-start justify-between gap-4">
                    <h2 className="font-heading text-lg font-semibold tracking-tight text-[#F2EEE3] transition-colors duration-200 group-hover:text-[#D8B54A]">
                      {article.title}
                    </h2>
                    <ArrowUpRight className="h-5 w-5 shrink-0 text-[#C6C0B4] transition-colors duration-200 group-hover:text-[#D8B54A]" />
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-[#B8B2A6]">{article.description}</p>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
